import type { LDProps } from 'launchdarkly-react-client-sdk';
import type { FragmentType } from 'src/gql';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { ManagedTagIcon } from 'src/components/net-worth/icons/managed-tag';
import { graphql, unmaskFragment } from 'src/gql';
import { accountSubtitle, accountTitle, renderIconForAccount } from 'src/utils/account';

import PortfolioAccountItemDescriptionRow from '../views/portfolio-account-item-description-row';
import PortfolioAndAccountItemDescriptionRow from '../views/portfolio-and-account-item-description-row';
import PortfolioItemDescriptionRow from '../views/portfolio-item-description-row';

export const PortfolioAccountDescriptionRowFragment = graphql(/* GraphQL */ `
  fragment PortfolioAccountDescriptionRow on Account {
    __typename
    accountNumber
    mask
    custody
    customNote
    ...AccountSubtitle
    ...AccountTitle
    ...RenderIconForAccount
  }
`);

function PortfolioAccountDescriptionRow({
  accountFrag,
  flags,
}: {
  readonly accountFrag: FragmentType<typeof PortfolioAccountDescriptionRowFragment>;
} & LDProps) {
  const account = unmaskFragment(PortfolioAccountDescriptionRowFragment, accountFrag);

  const icon = (
    <>
      {renderIconForAccount({ accountFrag: account })}
      {account.custody === 'managed' && (
        <div className="flex z-[1] -ml-3.5 -mb-1">
          <ManagedTagIcon />
        </div>
      )}
    </>
  );

  if (flags?.['customAccountNamesAndNotesV2']) {
    return (
      <div>
        <PortfolioAndAccountItemDescriptionRow
          icon={icon}
          title={accountTitle({ accountFrag: account })}
          subtitle={accountSubtitle({ accountFrag: account })}
          customNote={account.customNote}
          mask={account.mask}
          accountNumber={account.accountNumber}
        />
      </div>
    );
  }

  return (
    <div>
      {flags?.['customAccountNamesAndNotes'] ? (
        <PortfolioAccountItemDescriptionRow
          icon={icon}
          title={accountTitle({ accountFrag: account })}
          subtitle={accountSubtitle({ accountFrag: account })}
          customNote={account.customNote}
        />
      ) : (
        <PortfolioItemDescriptionRow
          icon={icon}
          title={accountTitle({ accountFrag: account })}
          subtitle={accountSubtitle({ accountFrag: account })}
        />
      )}
    </div>
  );
}
export default withLDConsumer()(PortfolioAccountDescriptionRow);
